var _defs, _path, _polygon, _polygon2, _path2, _path3, _polygon3, _circle, _path4, _circle2, _circle3, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgActiveCampaigns(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 331.25 244.47",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ffe079;}.cls-2{fill:#6ad3aa;}.cls-3{fill:#ff9a83;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M91.54,77.41h32.6v40.75h-16.3a4.07,4.07,0,0,0-4.07,4.07v65.2a4.07,4.07,0,0,0,4.07,4.07H116v48.89a4.08,4.08,0,0,0,4.07,4.08H242.3a4.08,4.08,0,0,0,4.07-4.08V191.5h8.15a4.08,4.08,0,0,0,4.08-4.07v-65.2a4.08,4.08,0,0,0-4.08-4.07h-6.7l4.62-15,7,9.31a4.08,4.08,0,0,0,7.13-1.16l8.15-24.45a4.11,4.11,0,0,0-.61-3.74L261.86,66.82a4.08,4.08,0,0,0-7.16,1.24l-12.4,40.32L229.9,68.07a4.08,4.08,0,0,0-7.16-1.25l-12.22,16.3a4.07,4.07,0,0,0-.61,3.74l8.15,24.44a4.07,4.07,0,0,0,7.13,1.16l7-9.31,4.61,15H201.55V77.41A28.55,28.55,0,0,0,173,48.89h-.45a28.52,28.52,0,1,0-39.84,0H101.38L78.13,25.64a4.09,4.09,0,0,0-5.77,0L60.14,37.86A4.07,4.07,0,0,0,60,43.43L88.48,76a4.07,4.07,0,0,0,3.06,1.38Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "260.14 78.11 266.28 86.3 261.26 101.34 255.39 93.52 260.14 78.11"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "223.33 101.34 218.32 86.3 224.46 78.11 229.2 93.52 223.33 101.34"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M238.22,236.32H124.14V191.5h24.45v32.6a4.07,4.07,0,0,0,5.68,3.74l26.91-11.53,26.92,11.53a4.08,4.08,0,0,0,5.68-3.74V191.5h24.44Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M156.73,191.5h48.9v26.41l-22.84-9.78a4.07,4.07,0,0,0-3.21,0l-22.85,9.78Z"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "250.45 183.35 242.3 183.35 120.06 183.35 111.92 183.35 111.92 126.31 250.45 126.31 250.45 183.35"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 152.66,
    cy: 28.52,
    r: 20.37
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M75.25,34.28,96.81,55.85A4.08,4.08,0,0,0,99.69,57H173A20.39,20.39,0,0,1,193.4,77.41v40.75H181.18V73.34H173v44.82H148.59V86.53l7.72-15.44L149,67.44l-8.15,16.3a4,4,0,0,0-.43,1.82v32.6h-8.15V73.34a4.08,4.08,0,0,0-4.08-4.07H93.39L68.6,40.93Z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 181.18,
    cy: 154.83,
    r: 20.37
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 181.18,
    cy: 154.83,
    r: 12.22
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M291.19,0H226a12.23,12.23,0,0,0-12.22,12.22V35L198.67,50.09A4.07,4.07,0,0,0,201.55,57h89.64a12.24,12.24,0,0,0,12.23-12.22V12.22A12.24,12.24,0,0,0,291.19,0Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M295.27,44.82a4.08,4.08,0,0,1-4.08,4.07h-79.8l9.34-9.34a4,4,0,0,0,1.2-2.88V12.22A4.08,4.08,0,0,1,226,8.15h65.19a4.08,4.08,0,0,1,4.08,4.07Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M230.07,16.3h57.05v8.15H230.07Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M230.07,32.6h57.05v8.14H230.07Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveCampaigns);
export default __webpack_public_path__ + "static/media/ActiveCampaigns.ce272e29b658c2ad7866aae0a6ea3c61.svg";
export { ForwardRef as ReactComponent };